import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import LockClockOutlinedIcon from '@mui/icons-material/LockClockOutlined';
import dayjs from 'dayjs';

interface ContactLockedNoticeProps {
  unlocksAt?: string;
  /** Whose contact details are locked, from the viewer's point of view. */
  audience: 'traveler' | 'guide';
  compact?: boolean;
}

export function formatUnlockTime(unlocksAt?: string) {
  const parsed = unlocksAt ? dayjs(unlocksAt) : null;
  return parsed?.isValid() ? parsed.format('ddd, D MMM · h:mm A') : null;
}

/** Shown in place of contact details until they unlock shortly before the trip (server-configured lead time). */
export function ContactLockedNotice({ unlocksAt, audience, compact = false }: ContactLockedNoticeProps) {
  const when = formatUnlockTime(unlocksAt);
  const whose = audience === 'traveler' ? 'Guide' : 'Traveler';
  const title = when ? `${whose} contact unlocks ${when}` : `${whose} contact unlocks shortly before the trip`;

  if (compact) {
    return (
      <Alert
        severity="info"
        icon={<LockClockOutlinedIcon fontSize="inherit" />}
        sx={{ py: 0.25, fontSize: '0.8125rem', borderRadius: 2 }}
      >
        {title}
      </Alert>
    );
  }

  return (
    <Alert severity="info" icon={<LockClockOutlinedIcon />} sx={{ borderRadius: 2 }}>
      <AlertTitle sx={{ fontWeight: 700 }}>{title}</AlertTitle>
      {audience === 'traveler'
        ? "For your safety, your guide's phone and WhatsApp are shared shortly before your trip. We'll notify you and email you when they're ready. Need help before then? Contact Trplin support."
        : "The traveler's phone number is shared shortly before the trip. You'll get a notification when it's available."}
    </Alert>
  );
}
